import { ButtonIcon, Tooltip, TooltipTrigger } from '@backstage/ui';
import { RiDeleteBinFill } from '@remixicon/react';

export interface ButtonIconDeleteProps {
  variant: 'tertiary' | 'primary' | 'secondary';
  size: 'small' | 'medium';
  isDisabled?: boolean;
  onClick: () => void;
}

export const ButtonIconDelete = (props: ButtonIconDeleteProps) => {
  const { variant, size, isDisabled, onClick } = props;
  return (
    <TooltipTrigger delay={100}>
      <ButtonIcon
        icon={<RiDeleteBinFill />}
        variant={variant}
        size={size}
        onClick={onClick}
        isDisabled={isDisabled ?? false}
      />
      <Tooltip placement="bottom">Delete</Tooltip>
    </TooltipTrigger>
  );
};
